export const formatTime = (time: number) => {
  const secondsNum = Math.floor(time / 1000);
  const minutesNum = Math.floor(secondsNum / 60);
  const hoursNum = Math.floor(minutesNum / 60);

  const hours = `${hoursNum}`.padStart(2, "0");
  const minutes = `${minutesNum % 60}`.padStart(2, "0");
  const seconds = `${secondsNum % 60}`.padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};
